(ns app.front.view.group.admin.fees.settings
  (:require [app.front.ui.section :as section]
            [app.front.view.group.admin.config.counter-config-editor :as counter-config-editor]
            [app.front.view.group.admin.feature-toggle :as feature-toggle]
            [app.front.view.group.admin.subs :as gas]
            [core.front.event :refer [<sub]]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]))

(rf/reg-event-fx ::init
  (fn [_ [_ authority-group-id]]
    {:dispatch-n [[::fetch-counter-config authority-group-id]]}))

(rf/reg-event-fx ::fetch-counter-config
  (fn [_ [_ group-id]]
    {:comm/command {:command    :fee/get-bill-invoice-counter-config
                    :method     :get
                    :data       {:authority-group-id group-id}
                    :on-success [:app.front.entities/merge-entity-db]}}))

(defn- bill-invoice-number-counter-config [tr group-id]
  [:<>
   [:div.mb-2.text-sm (tr [:fees/bill-invoice-numbering-instruction])]
   [counter-config-editor/counter-config-editor
    (util/mmap {:counter-config-type :counter-config.type/bill-invoice-number}
               tr
               group-id)]])

(defn view []
  (let [tr       (<sub [::gas/group-tr])
        group-id (<sub [::gas/group-id])]
    [:<>
     [section/section
      "settings"
      {:tr tr}
      (tr [:fees/settings])
      [:<>
       [feature-toggle/toggle-group-feature
        (util/mmap {:feature-name :group.feature/bill-invoice-numbering}
                   tr)]
       (when (<sub [::gas/has-feature? :group.feature/bill-invoice-numbering])
         [bill-invoice-number-counter-config tr group-id])
       [feature-toggle/toggle-group-feature
        (util/mmap {:feature-name :group.feature/show-wizard-estimated-costs
                    :feature-flag :feature-flag.id/wizard-estimate-costs}
                   tr)]]]]))
